// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"884":"admin","933":"auth"}[chunkId] || chunkId) + "." + {"34":"5e777fb3","112":"3d727c85","186":"923086a5","375":"5bb08052","612":"f953dcee","859":"73be2630","884":"819254bd","933":"d0ee8d58"}[chunkId] + ".chunk.js";
};